export default __webpack_public_path__ + "static/media/OnuoraOkeke.247325e3.svg";